import createModel from 'utils/model'
import {memberInfo} from 'crm/services/ming-chuang'

export default createModel({
    namespace: 'crm_mingChuang',
    state: {},

    subscriptions: {},

    effects: {
        *memberInfo({payload}, {call}) {
            return yield call(memberInfo, payload)
        },
    },

    reducers: {},
})
